import { SheetFooter } from '@/components/ui/sheet'
import { Skeleton } from '@/components/ui/skeleton'

type Props = {
  showUserSummary?: boolean
}

export const UpdateUserAccessFallback = ({ showUserSummary = true }: Props) => {
  return (
    <>
      <div className="px-4 overflow-y-auto">
        {showUserSummary ? (
          <div className="mb-6 flex items-center gap-3 rounded-lg border bg-muted/30 px-3 py-3 text-left">
            <Skeleton className="h-10 w-10 rounded-lg" />
            <div className="grid min-w-0 flex-1 gap-2 text-sm leading-tight">
              <Skeleton className="h-4 w-36" />
              <Skeleton className="h-3 w-48" />
            </div>
          </div>
        ) : null}
        <Skeleton className="h-3.5 w-[84px] mb-2" />
        <Skeleton className="h-9 w-full mb-5" />
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-1.5">
            <div className="flex gap-2">
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-3.5 w-[170px]" />
            </div>
            <Skeleton className="h-3.5 w-[315px] ml-6" />
          </div>
          <div className="flex flex-col gap-1.5">
            <div className="flex gap-2">
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-3.5 w-[150px]" />
            </div>
            <Skeleton className="h-3.5 w-[270px] ml-6" />
          </div>
          <div className="flex flex-col gap-1.5">
            <div className="flex gap-2">
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-3.5 w-[130px]" />
            </div>
            <Skeleton className="h-3.5 w-[280px] ml-6" />
          </div>
        </div>
      </div>
      <SheetFooter className="sticky">
        <Skeleton className="h-9 w-full" />
      </SheetFooter>
    </>
  )
}
